import { action } from '@storybook/addon-actions';
import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

/**
 * Default Values for Split Pane
 */
export const DEFAULT_GRABBABLE_HEIGHT = 30 + 1; // grabbable height + border
export const DEFAULT_OFFSET = 0;

/** The split panes have a height calculated from the available vertical height
 * which does not account for padding or borders. The following are the
 * current padding values as of 4.3.0, which allows for flexible height areas
 * in the panes to grow without pushing down any stationary elements (like
 * the buttons which are stuck to bottom pane).
 */
export const TOTAL_VERTICAL_PADDING = 18;
export const ADDRESS_PADDING = 8;
export const CARD_PADDING = 10 * 2;
export const CHAT_HEADER_HEIGHT = 60;
export const CHAT_MESSAGE_PADDING = 25;

export const WindowSimulator = styled(Box).attrs({
  bg: 'lightLineDivider',
  width: '100%',
  p: 10,
})`
  height: ${({ height }) => height}px;
  border: ${({ theme }) => `1px solid ${theme.colors.heavyLineOutline}`};
`;

export const ChatPlaceholder = styled(Box).attrs({
  bg: 'background',
  p: 3,
})``;

export const mockStore = {
  getState: () => {
    return {
      sinatra: {
        user: {
          currentRole: {
            application: 'capstone',
          },
        },
        irp: {
          irp_access_token: null,
          queryURI: null,
          irpVersion: '0',
        },
      },
      alertsRouting: {
        agencyLinks: [],
      },
      incidents: {
        alerts: {},
        selectedAlertID: 'alert-c111-222b-a333-d4dd',
      },
    };
  },
  subscribe: () => 0,
  dispatch: action('dispatch'),
};
